export const sortBy = <T, S>(data: T[], reference: S[], check: (a: T, b: S) => boolean) => {
	return reference
		.map((rItem) => data.find((dItem) => check(dItem, rItem)))
		.filter(Boolean)
		.map((item) => item!);
};
